import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Banner from '../Banner/Banner';
import TopProjects from '../TopProjects/TopProjects';
import Footer from '../../Shared/Footer/Footer';
import Header from '../../Shared/Header/Header';
import Loader from '../../../components/Loader';
import { useApp } from '../../../contexts/AppContext';

const Home = () => {
  // const [isLoading, setIsLoading] = useState(true);
  const { isInitialLoad } = useApp();
  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 2000000);
  // }, []);
  const [showLoader, setShowLoader] = useState(true);

  // const toggleLoadingState = () => {
  //   setShowLoader(!showLoader);
  // };

  return (
    <>
      <AnimatePresence mode='wait'>
        {!isInitialLoad && <Loader showLoader={showLoader} setShowLoader={setShowLoader} />}
        <div>
          <Header></Header>
          <Banner></Banner>
          <TopProjects></TopProjects>
          <Footer></Footer>
        </div>
      </AnimatePresence>
    </>
  );
};

export default Home;
